<template>
  <div class="banner">
    <div
      v-if="!!picture"
      :style="{ 'max-height': maxHeight }"
      class="sf-image banner-image"
      :class="{ 'banner-image-full-width': fullWidth }"
    >
      <img :src="picture" :alt="picture" />
    </div>
    <div class="content">
      <slot v-if="description" name="description" v-bind="{ description }">
        <div v-html="description" class="description" />
      </slot>
      <slot name="call-to-action" v-if="link">
        <SfButton :link="link" class="all-to-action-button" :target="isBlank(link)">
          {{ buttonText || $t("More Details") }}
        </SfButton>
      </slot>
    </div>
  </div>
</template>
<script>
import { SfButton } from '@storefront-ui/vue';

export default {
  name: 'Banner',
  components: {
    SfButton,
  },
  props: {
    maxHeight: {
      type: String,
      default: '32Opx',
    },
    description: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    picture: {
      type: [String, Object],
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    fullWidth: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    isBlank(link) {
      return link.includes('backoffice') ? '_blank' : undefined;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";

/deep/ h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/deep/ h2 {
  font-size: 1.5em;
  margin: 0.83em 0;
}

/deep/ h3 {
  font-size: 1.17em;
  margin: 1em 0;
}

/deep/ h4 {
  font-size: 1em;
  margin: 1.33em 0;
}

/deep/ h5 {
  font-size: 0.83em;
  margin: 1.67em 0;
}

/deep/ h6 {
  font-size: 0.75em;
  margin: 2.33em 0;
}

.banner {
  position: relative;
}

.content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 95%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.banner-image {
  max-height: 320px;
  width: 100%;
  & /deep/ img {
    max-width: 100%;
    margin: 0 auto;
    display: block;
  }
}

.banner-image-full-width {
  & /deep/ img {
    width: 100%;
  }
}

.description {
  @include flexbox-mobile {
    display: none;
  }
}

.all-to-action-button {
  width: auto;
}
</style>
